module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./public/app/modules/my-content/view-content/view-content.component.css
// module id = ./public/app/modules/my-content/view-content/view-content.component.css
// module chunks = main